import { render, staticRenderFns } from "./ActorMessageFormBySetting.vue?vue&type=template&id=ece9e9de"
import script from "./ActorMessageFormBySetting.vue?vue&type=script&lang=js"
export * from "./ActorMessageFormBySetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports